import React from "react";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import DivisionForm from "./components/divisionForm";
import DivisionGrid from "./components/divisionGrid";
import { useDivisionAdmin } from "./hooks/useDivisionAdmin";
import Header from "components/Header";

function DivisionAdmin() {
  const {
    isLargeScreen,
    open,
    editMode,
    currentDivision,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
    showOrg,
  } = useDivisionAdmin();

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="ALT Coach Subject Admin"
            subtitle="Administer your subject details"
          />
          {showOrg && (
            <Button
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "5px",
                fontSize: "12px",
                padding: "5px 10px",
              }}
              onClick={handleOpen}
            >
              <GroupAddOutlinedIcon sx={{ mr: "0.5rem" }} />
              Add new Subject
            </Button>
          )}
        </FlexBetween>

        <DivisionGrid handleEditOpen={handleEditOpen} />

        {/* The Dialog component is a modal dialog that is displayed over the current page. */}
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>
            {editMode
              ? `Edit Subject - ${currentDivision.name}`
              : "Add a New Subject to your School"}
          </DialogTitle>
          <DialogContent>
            <DivisionForm
              editMode={editMode}
              currentDivision={currentDivision}
              setOpen={setOpen}
              handleClose={handleClose}
            />
          </DialogContent>
        </Dialog>
      </WidgetWrapper>
    </Box>
  );
}

export default DivisionAdmin;
